import { genericActions } from "../_helpers/ActionErrorWrapper";

import { LocationsService } from "../_services/LocationsService";
import { DistributorLocationMapper } from "../_mappers/DistributorLocationMapper";

export const LocationsActions = {
    getLocationById,
    getLocationsByAdminEmail,
};

function getLocationById(locationId) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            const serverLocation = await LocationsService.getLocationById(locationId);
            return DistributorLocationMapper.serverToLocal(serverLocation);
        }
    };
}

function getLocationsByAdminEmail(email) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, null, true));

        async function asyncAction() {
            const serverLocations = await LocationsService.getLocationsByAdminEmail(email);
            return DistributorLocationMapper.allServerToLocal(serverLocations);
        }
    };
}
